import React from "react";
import { Gift } from "lucide-react";

// Rendering della gift card (tema scelto dall'acquirente + grafica del circuito sovrapposta)
export function GiftCardVisual({ theme, image_url, amount, code, recipient_name, sender_name, app_name, compact = false, thumb = false, testid = "giftcard-visual" }) {
  const t = theme || { from: "#1E40AF", to: "#1E3A8A" };
  const raw = theme?.image_url || image_url;
  const img = raw && raw.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${raw}` : raw;
  if (thumb) {
    return (
      <div className="relative w-full aspect-[1.6] rounded-xl overflow-hidden shadow text-white" style={{ background: `linear-gradient(135deg, ${t.from} 0%, ${t.to} 100%)` }} data-testid={testid}>
        {img && <img src={img} alt="" className="absolute inset-0 h-full w-full object-cover opacity-90" />}
        <Gift className="absolute top-2 left-2 h-3.5 w-3.5 opacity-90" />
        <span className="absolute bottom-2 left-2 h-1 w-6 rounded bg-white/70" />
      </div>
    );
  }
  return (
    <div className={`relative w-full ${compact ? "aspect-[1.75]" : "aspect-[1.6]"} rounded-3xl overflow-hidden shadow-xl text-white`} style={{ background: `linear-gradient(135deg, ${t.from} 0%, ${t.to} 100%)` }} data-testid={testid}>
      {img && <img key={img} src={img} alt="" className="absolute inset-0 h-full w-full object-cover opacity-90" />}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
      <div className="absolute top-4 left-5 right-5 flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest" style={{ color: "rgba(255,255,255,0.9)" }}><Gift className="h-3.5 w-3.5" /> Gift Card{app_name ? ` · ${app_name}` : ""}</span>
        {t.label && <span className="text-[10px] font-semibold bg-white/20 rounded-full px-2 py-0.5" style={{ color: "#fff" }}>{t.label}</span>}
      </div>
      <div className="absolute bottom-4 left-5 right-5">
        {amount != null && <div className={`font-heading font-extrabold ${compact ? "text-2xl" : "text-4xl"}`} style={{ color: "#fff" }}>€ {Number(amount).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>}
        <div className="flex items-end justify-between gap-3 mt-1">
          <div className="text-xs truncate" style={{ color: "rgba(255,255,255,0.9)" }}>{recipient_name ? `Per ${recipient_name}` : ""}{sender_name ? ` · da ${sender_name}` : ""}</div>
          {code && <div className="font-mono text-xs tracking-widest bg-black/30 rounded-md px-2 py-1" style={{ color: "#fff" }} data-testid={`${testid}-code`}>{code}</div>}
        </div>
      </div>
    </div>
  );
}
